import React from "react";

export default function InboxBar({ swaps = 0, covers = 0, timeoff = 0, onClick }) {
  const total = swaps + covers + timeoff;
  if (total === 0) return null;

  const isUrgent = swaps > 0 || covers > 0;
  const bg = isUrgent ? "bg-[#FF5A1F]" : "bg-[#0A0A0A]";

  const parts = [];
  if (swaps > 0) parts.push(`${swaps} swap${swaps !== 1 ? "s" : ""}`);
  if (covers > 0) parts.push(`${covers} cover${covers !== 1 ? "s" : ""}`);
  if (timeoff > 0) parts.push(`${timeoff} time off`);
  const summary = parts.join(" · ");

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onClick ? (e) => (e.key === "Enter" || e.key === " ") && onClick(e) : undefined}
      className={[
        "w-full rounded-xl p-4 flex items-center justify-between gap-3",
        "cursor-pointer transition-transform duration-150 hover:-translate-y-0.5",
        bg,
      ].join(" ")}
    >
      {/* Left */}
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg bg-white/15 flex items-center justify-center font-bold text-sm text-white flex-shrink-0">
          {total}
        </div>
        <div className="flex flex-col">
          <span className="text-[11px] font-bold uppercase tracking-widest text-white opacity-70 leading-none mb-[3px]">
            Pending
          </span>
          <span className="text-[14px] font-bold text-white leading-tight">
            {summary}
          </span>
        </div>
      </div>

      {/* Right */}
      <span className="text-white opacity-60 text-[20px] leading-none">→</span>
    </div>
  );
}
